import React, { useContext } from 'react'
import { AnalyticsContext } from '../analyticsContext'
import { getDisplayName } from './displayName'

const withAnalyticsContext = WrappedComponent => {
  const Wrapper = props => {
    const analytics = useContext(AnalyticsContext)

    return <WrappedComponent {...props} {...analytics} />
  }

  Wrapper.getInitialProps = async ctx => {
    const componentProps =
      WrappedComponent.getInitialProps &&
      (await WrappedComponent.getInitialProps(ctx))

    return { ...componentProps }
  }

  Wrapper.displayName = `withAnalyticsContext${getDisplayName(WrappedComponent)}`

  return Wrapper
}

export default withAnalyticsContext
